<!--<c-footer>-->
<div>
  <!-- <a href="#" target="_blank"></a>
    <span> &copy; 2023 creativeLabs</span> -->
</div>
<div class="ms-auto">
  Powered by
  <a href="#" target="_blank">
    <span> Anonymous Gaming</span>
  </a>
</div>
<!--</c-footer>-->
